export const isArrayFilled = (array: unknown[], minLength: number): boolean => {
  return Array.isArray(array) && array.length > minLength
}
